function refresh() {
  location.reload();
}

function logout() {
  http
    .post("/logout")
    .then(() => {
      refresh();
    })
    .catch(() => {
      window.location.href = "/";
    });
}

function uuid(n = 12) {
  let text = "";
  let possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < n; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}

function fillFields(template, data) {
  const filledTemplate = {};

  Object.keys(template).forEach(key => {
    if (data[key] !== undefined) {
      filledTemplate[key] = _.cloneDeep(data[key]);
    } else {
      filledTemplate[key] = _.cloneDeep(template[key]);
    }
  });

  return filledTemplate;
}

window.refresh = refresh;
window.logout = logout;
window.uuid = uuid;

export { uuid, logout, refresh, fillFields };

/*
|--------------------------------------------------------------------------
| String Helpers
|--------------------------------------------------------------------------
*/

/** Capitalize */
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

/** Phone Format */
String.prototype.phoneFormat = function () {
  return `(${this.slice(0, 3)}) ${this.slice(3, 6)}-${this.slice(6, 10)}`;
};

/** Truncate string */
String.prototype.limit = function (count) {
  return this.slice(0, count) + (this.length > count ? "..." : "");
};

/*
|--------------------------------------------------------------------------
| Number Helpers
|--------------------------------------------------------------------------
*/

/** Number Format */
Number.prototype.format = function (n = undefined) {
  new Intl.NumberFormat(window.Laravel.app.locale, {
    minimumFractionDigits: n,
    maximumFractionDigits: n
  }).format(this);
};

/** Percentage Format */
Number.prototype.percentageFormat = function (n = undefined) {
  return new Intl.NumberFormat(window.Laravel.app.locale, {
    style: "percent",
    minimumFractionDigits: n,
    maximumFractionDigits: n
  }).format(this);
};

/** Price Format */
Number.prototype.priceFormat = function (n = 2) {
  return new Intl.NumberFormat(window.Laravel.app.locale, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: n,
    maximumFractionDigits: n
  }).format(this);
};

Number.prototype.fileSizeFormat = function () {
  let i = Math.floor(Math.log(this) / Math.log(1024));
  return (
    (this / Math.pow(1024, i)).toFixed(2) * 1 +
    " " +
    ["B", "kB", "MB", "GB", "TB"][i]
  );
};

/*
|--------------------------------------------------------------------------
| Date Helpers
|--------------------------------------------------------------------------
*/

/** Date to String */
Date.prototype.format = function () {
  let date = new Date(this.getTime());
  let month = "" + (date.getMonth() + 1),
    day = "" + date.getDate(),
    year = date.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

/*
|--------------------------------------------------------------------------
| Image Helpers
|--------------------------------------------------------------------------
*/

function resizeImage(file, max = 100) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = e => {
      let image = new Image();
      image.src = e.target.result;
      image.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0);

        let MAX_WIDTH = max;
        let MAX_HEIGHT = max;
        let width = image.width;
        let height = image.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }

        canvas.width = width;
        canvas.height = height;
        let ctx2 = canvas.getContext("2d");
        ctx2.drawImage(image, 0, 0, width, height);

        let dataurl = canvas.toDataURL(file.type);
        let arr = dataurl.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        let resizedFile = new File([u8arr], file.name, { type: mime });

        resolve(resizedFile);
      };
    };

    reader.readAsDataURL(file);
  });
}

import { heicTo } from "heic-to";

async function convertHeicImage(file, toMimeType = "image/jpeg", extension = "jpg") {
  try {
    if (!file || file.type !== "image/heic") {
      return file;
    }

    const outputBuffer = await heicTo({
      blob: file,
      format: toMimeType,
      quality: 0.5
    });

    let newFile = new File([outputBuffer], file.name + "." + extension, { type: toMimeType });

    return newFile;

  } catch (error) {
    console.error("HEIC Conversion Error:", error);
    return file; // Return original file if conversion fails
  }
}


export { resizeImage, convertHeicImage };
